/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Component } from "react";
import PropTypes from "prop-types";
import withTranslation from "../../translation";
import { navigationPropType } from "@template/state/modules/navigation";
import {
  viewportPropType,
  LARGE_VIEWPORT
} from "@template/state/modules/layout";
import { isWindowDefined } from "@src/helpers/url";
import { getDesktopTemplate } from "@template/helpers/navigationTemplatesResolver";
import { globalEventHandler, events, keys } from "@template/globalEventHandler";
import {
  ProgressIndicator,
  SIZE_MEDIUM
} from "@asosteam/asos-web-component-library-progress-indicator";

import styles from "./index.css";
import classnames from "classnames/bind";

const cx = classnames.bind(styles);

const inferTemplateComponent = item => {
  const { largeScreenTemplateId } = item;
  const TemplateComponent = getDesktopTemplate(largeScreenTemplateId);
  return <TemplateComponent item={item} />;
};

class LargeSecondaryNavigation extends Component {
  isVisible = () => {
    return (
      this.props.item.id === this.props.largeNavActiveItemId &&
      this.props.viewport === LARGE_VIEWPORT
    );
  };
  globalTrackingTimer = null;

  isLeftKey = event => event.key === keys.left;

  isShiftTabKey = event => event.key === keys.tab && event.shiftKey;

  isTabKey = event => event.key === keys.tab && !event.shiftKey;

  isEscKey = event => event.key === keys.escape;

  isFirstItemFocused = () => !!document.activeElement.dataset.first;

  isLastItemFocused = () => !!document.activeElement.dataset.last;

  handleKeyDown = event => {
    const {
      clearNavActiveItem,
      item: { id }
    } = this.props;
    if (this.isVisible()) {
      if (this.isEscKey(event)) {
        clearNavActiveItem();
        document.querySelector(`button[data-id="${id}"]`).focus();
      } else if (
        this.isFirstItemFocused() &&
        (this.isShiftTabKey(event) || this.isLeftKey(event))
      ) {
        event.preventDefault();
        event.stopPropagation();
        clearNavActiveItem();
        document.querySelector(`button[data-id="${id}"]`).focus();
      } else if (this.isLastItemFocused() && this.isTabKey(event)) {
        clearNavActiveItem();
      }
    }
  };

  componentDidMount() {
    const { hasClickedInside, clearNavActiveItem } = this.props;

    this.globalClickListener = globalEventHandler.addListener(
      events.click,
      event => {
        if (this.isVisible() && !hasClickedInside(event)) {
          clearNavActiveItem();
        }
      }
    );
  }

  componentWillUnmount() {
    this.globalClickListener && this.globalClickListener.remove();
  }

  renderHeading = (label, id, isHidden) => {
    if (!label) return null;

    return (
      <h4
        id={id}
        className={cx(styles.columnHeader, {
          [styles.hidden]: isHidden
        })}
      >
        <span>{label}</span>
      </h4>
    );
  };

  renderContainer = item => {
    const { id, label, largeScreenStyleType, largeScreenColumnSpan } = item;
    const isHiddenTitle = largeScreenStyleType === "noTitle";

    return (
      <div
        key={id}
        className={cx(
          styles.column,
          styles[`colspan-${largeScreenColumnSpan || 1}`]
        )}
      >
        {this.renderHeading(label, id, isHiddenTitle)}
        {inferTemplateComponent(item)}
      </div>
    );
  };

  render() {
    const {
      item: primaryNavItem,
      item: { items: secondaryNavItems },
      clearNavActiveItem,
      formatTranslation
    } = this.props;
    const classes = cx(styles.container, {
      [styles.visible]: this.isVisible()
    });

    const hasNoItems = !secondaryNavItems.length;

    //The window type checking is a work around to
    //make the classes match server and client side
    const flyoutClasses = cx(styles.flyout, {
      [styles.isLoading]: hasNoItems || !isWindowDefined()
    });

    return (
      <div
        className={classes}
        data-testid="secondarynav-container"
        ref={c => (this.container = c)}
      >
        <div
          className={styles.backdrop}
          onClick={clearNavActiveItem}
          onMouseMove={clearNavActiveItem}
          aria-hidden="true"
          data-testid="backdrop"
        />
        <div className={styles.flyoutContainer}>
          <div
            className={flyoutClasses}
            data-id={primaryNavItem.id}
            data-testid="secondarynav-flyout"
            onKeyDown={this.handleKeyDown}
          >
            {hasNoItems ? (
              <div className={styles.progressIndicatorContainer}>
                <ProgressIndicator
                  size={SIZE_MEDIUM}
                  progressMessage={formatTranslation(
                    "accessibility_label_loading"
                  )}
                />
              </div>
            ) : (
              secondaryNavItems.map((secondaryNavItem, index) => {
                return this.renderContainer({
                  ...secondaryNavItem,
                  isFirstColumn: index === 0,
                  isLastColumn: index === secondaryNavItems.length - 1
                });
              })
            )}
          </div>
        </div>
      </div>
    );
  }

  static propTypes = {
    item: navigationPropType.isRequired,
    largeNavActiveItemId: PropTypes.string,
    setNavActiveItem: PropTypes.func.isRequired,
    clearNavActiveItem: PropTypes.func.isRequired,
    buttonElement: PropTypes.object,
    viewport: viewportPropType.isRequired,
    hasClickedInside: PropTypes.func.isRequired,
    testIsLoaded: PropTypes.bool,
    formatTranslation: PropTypes.func.isRequired
  };
}

export default withTranslation(LargeSecondaryNavigation);
